import {Box, Heading} from '@primer/react'
import type {ReactNode} from 'react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {testIdProps} from '@github-ui/test-id-props'
import {useNextHeaderTag} from '../hooks/use-next-header-tag'

export type NestedListViewHeaderTitleProps = {
  title: string
  children?: ReactNode
}

export const NestedListViewHeaderTitle = ({title, children}: NestedListViewHeaderTitleProps) => {
  const defaultStyles: BetterSystemStyleObject = {
    p: 2,
    borderBottomColor: 'border.muted',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 1,
  }

  const headerStyles: BetterSystemStyleObject = {
    display: 'flex',
    px: 2,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: 1,
  }

  const titleTag = useNextHeaderTag('nested-listview-metadata')

  return (
    <Box sx={defaultStyles}>
      <Heading as={titleTag} sx={headerStyles} {...testIdProps('nested-list-view-header-title')}>
        {title}
      </Heading>
      {children}
    </Box>
  )
}

try{ NestedListViewHeaderTitle.displayName ||= 'NestedListViewHeaderTitle' } catch {}